// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.locationName--LEVSd {
  color: rgb(80, 80, 80);
}

.subjectName--YWNey {
  font-weight: 700;
}

[dir=ltr] .titleWrapper--CMs4b {
  padding-right: 40px;
}

[dir=rtl] .titleWrapper--CMs4b {
  padding-left: 40px;
}

[dir=ltr] .summaryWrapper--FPWCA {
  border-left: 1px solid #d8d8d8;
}

[dir=rtl] .summaryWrapper--FPWCA {
  border-right: 1px solid #d8d8d8;
}

.summaryIcon--hAz4O {
  display: inline-block;
}

[dir=ltr] .summaryIcon--hAz4O {
  margin: 10px 20px 10px 0;
}

[dir=rtl] .summaryIcon--hAz4O {
  margin: 10px 0 10px 20px;
}

.positiveChange--awRwU {
  color: #657a2a;
}
.negativeChange--aGQui {
  color: #df1b12;
}
`, "",{"version":3,"sources":["webpack://./src/js/components/DriversOfChangeHeader/styles.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAFA;EACE,kBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAFA;EACE,+BAA8B;AAChC;;AAEA;EACE,qBAAqB;AAEvB;;AAHA;EAEE,wBAAwB;AAC1B;;AAHA;EAEE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB","sourcesContent":[".locationName {\n  color: rgb(80, 80, 80);\n}\n\n.subjectName {\n  font-weight: 700;\n}\n\n.titleWrapper {\n  padding-right: 40px;\n}\n\n.summaryWrapper {\n  border-left: 1px solid #d8d8d8;\n}\n\n.summaryIcon {\n  display: inline-block;\n  margin: 10px 20px 10px 0;\n}\n\n.positiveChange {\n  color: #657a2a;\n}\n.negativeChange {\n  color: #df1b12;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"locationName": `locationName--LEVSd`,
	"subjectName": `subjectName--YWNey`,
	"titleWrapper": `titleWrapper--CMs4b`,
	"summaryWrapper": `summaryWrapper--FPWCA`,
	"summaryIcon": `summaryIcon--hAz4O`,
	"positiveChange": `positiveChange--awRwU`,
	"negativeChange": `negativeChange--aGQui`
};
export default ___CSS_LOADER_EXPORT___;
